import { render, staticRenderFns } from "./PModal.vue?vue&type=template&id=68308154&scoped=true&"
import script from "./PModal.vue?vue&type=script&lang=js&"
export * from "./PModal.vue?vue&type=script&lang=js&"
import style0 from "./PModal.vue?vue&type=style&index=0&id=68308154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68308154",
  null
  
)

export default component.exports